module.exports = __webpack_public_path__ + "img/placket width.786a0fe2.png";